(() => {
  const states = new WeakMap();
  let scheduled = false;
  const text = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
  function stateFor(root) {
    if (!states.has(root)) states.set(root, { confirmed: root.dataset.rfExplicitVariant === 'true', error: false });
    return states.get(root);
  }
  function sizeField(root) { return root.querySelector('fieldset[data-rf-option="size"]'); }
  function nativeButton(root) { return root.querySelector('product-form [name="add"]'); }
  function syncMembership(root) {
    if (root.dataset.rfMember !== 'true') return;
    const form = root.querySelector('product-form form');
    const mount = root.querySelector('[data-rf-subscription-mount]');
    const fallback = root.querySelector('[data-rf-plan-fallback]');
    const select = root.querySelector('[data-rf-plan-select]');
    if (!form || !select) return;
    const container = mount?.querySelector('.shopify_subscriptions_app_block_container') || document.querySelector('.shopify_subscriptions_app_block_container');
    const checked = container?.querySelector('input[data-selling-plan-id]:checked');
    const appInput = container?.querySelector('input[name="selling_plan"]');
    if (mount && container && checked && appInput) {
      if (!mount.contains(container)) mount.append(container);
      appInput.setAttribute('form', form.getAttribute('id'));
      appInput.value = checked.dataset.sellingPlanId;
      if (appInput.disabled) appInput.disabled = false;
      select.value = checked.dataset.sellingPlanId;
      if (!select.disabled) select.disabled = true;
      fallback.hidden = true;
    } else {
      if (select.disabled) select.disabled = false;
      fallback.hidden = false;
    }
    const option = select.selectedOptions[0];
    if (option?.dataset.price) {
      root.querySelectorAll('[id^="price-"] .price-item--regular, [id^="price-"] .price-item--sale').forEach(node => text(node, option.dataset.price));
    }
  }
  function update(root) {
    const state = stateFor(root);
    const field = sizeField(root);
    const unconfirmed = !!field && !state.confirmed;
    root.classList.toggle('rf-size-unconfirmed', unconfirmed);
    const message = root.querySelector('[data-rf-size-message]');
    if (message) {
      message.hidden = !unconfirmed;
      if (state.error) { message.setAttribute('role','alert'); text(message, root.dataset.rfSizeError); }
    }
    const button = nativeButton(root);
    if (button && !button.disabled && button.getAttribute('aria-disabled') !== 'true') {
      const label = button.querySelector('span');
      if (unconfirmed) text(label, root.dataset.rfSizeLabel);
      else if (label?.textContent === root.dataset.rfSizeLabel) text(label, root.dataset.rfAddLabel);
    }
    syncMembership(root);
    const sticky = [...document.querySelectorAll('[data-rf-sticky]')].find(node => node.dataset.section === root.dataset.section);
    if (!sticky || !button) return;
    const action = sticky.querySelector('[data-rf-sticky-action]');
    const member = root.dataset.rfMember === 'true';
    const price = root.querySelector('[id^="price-"] .price--on-sale .price-item--sale, [id^="price-"] .price:not(.price--on-sale) .price__regular .price-item--regular')?.textContent.trim() || '';
    const chosenSize = field?.querySelector('input:checked')?.value;
    text(sticky.querySelector('[data-rf-sticky-detail]'), [price, unconfirmed ? root.dataset.rfSizeLabel : chosenSize].filter(Boolean).join(' · '));
    text(action, member ? sticky.dataset.memberLabel : unconfirmed ? sticky.dataset.sizeLabel : button.querySelector('span')?.textContent.trim() || sticky.dataset.addLabel);
    const unavailable = !member && !unconfirmed && (button.disabled || button.getAttribute('aria-disabled') === 'true');
    if (action.disabled !== unavailable) action.disabled = unavailable;
    sticky.hidden = button.getBoundingClientRect().bottom > 0;
  }
  function refresh() {
    scheduled = false;
    document.querySelectorAll('[data-rf-product]').forEach(update);
  }
  function schedule() { if (!scheduled) { scheduled = true; requestAnimationFrame(refresh); } }
  function requestSize(root) {
    const state = stateFor(root); state.error = true;
    update(root);
    const field = sizeField(root);
    field?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    field?.querySelector('input:not(.disabled)')?.focus({ preventScroll:true });
  }
  document.addEventListener('click', event => {
    const fitLink = event.target.closest('[data-rf-open-fit]');
    if (fitLink) {
      const details = document.getElementById(fitLink.getAttribute('href').slice(1));
      if (details) { event.preventDefault(); details.open = true; details.scrollIntoView({behavior:'smooth',block:'center'}); details.querySelector('summary')?.focus({preventScroll:true}); }
    }
    const root = event.target.closest('[data-rf-product]');
    if (root && event.target.closest('[data-rf-option="size"]') && !fitLink) {
      const control = event.target.closest('input, label');
      if (control) { stateFor(root).confirmed = true; stateFor(root).error = false; schedule(); }
    }
    const action = event.target.closest('[data-rf-sticky-action]');
    if (!action) return;
    const section = action.closest('[data-rf-sticky]').dataset.section;
    const product = [...document.querySelectorAll('[data-rf-product]')].find(node => node.dataset.section === section);
    if (!product) return;
    if (sizeField(product) && !stateFor(product).confirmed) { requestSize(product); return; }
    const button = nativeButton(product);
    if (product.dataset.rfMember === 'true') {
      product.querySelector('.rf-member-product')?.scrollIntoView({behavior:'smooth',block:'start'});
      const target=product.querySelector('[data-rf-subscription-mount] input[type="radio"], [data-rf-plan-select]');
      target?.scrollIntoView({behavior:'smooth',block:'center'});target?.focus({preventScroll:true});
    } else if (button && !button.disabled && button.getAttribute('aria-disabled') !== 'true') button.click();
    else button?.scrollIntoView({behavior:'smooth',block:'center'});
  });
  document.addEventListener('change', event => {
    const root = event.target.closest('[data-rf-product]');
    if (root && event.target.closest('[data-rf-option="size"]')) { stateFor(root).confirmed = true; stateFor(root).error = false; }
    schedule();
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    const root = form.closest('[data-rf-product]');
    if (!root || !form.matches('product-form form')) return;
    if (sizeField(root) && !stateFor(root).confirmed) { event.preventDefault(); event.stopImmediatePropagation(); requestSize(root); return; }
    syncMembership(root);
  }, true);
  function boot() {
    refresh();
    const observer=new MutationObserver(schedule);
    observer.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled','aria-disabled']});
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',schedule,{passive:true});
    document.addEventListener('shopify:section:load',schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot,{once:true}); else boot();
})();
